/* eslint-disable func-style */
const BasicInformation = () => import('../../pages/StudentInformation/BasicInformation');
const AmendRecord = () => import('../../pages/StudentInformation/AmendRecord');
const BasicAddExcel = () => import('../../pages/StudentInformation/BasicAddExcel');
const BasicUpdateExcel = () => import('../../pages/StudentInformation/BasicUpdateExcel');
const EditStudentInfo = () => import('../../pages/StudentInformation/EditStudentInfo');
const SquadManage = () => import('../../pages/StudentInformation/SquadManage');
const SquadManageExcel = () => import('../../pages/StudentInformation/SquadManageExcel');
const ReliefInformation = () => import('../../pages/StudentInformation/ReliefInformation.vue');
const StuDelayInfo = () => import('../../pages/StudentInformation/StuDelayInfo.vue');
const TransactionInfo = () => import('../../pages/StudentInformation/TransactionInfo.vue');
const DiffManagement = () => import('../../pages/StudentInformation/DiffManagement.vue');
const BriefDepositControl = () => import('../../pages/StudentInformation/BriefDepositControl.vue');
const ReliefInformationExcel = () => import('../../pages/StudentInformation/ReliefInformationExcel.vue');
const StuDelayInfoExcel = () => import('../../pages/StudentInformation/StuDelayInfoExcel.vue');
const LoansInformation = () => import('../../pages/StudentInformation/LoansInformation.vue');
const LoansRightPanelDetails = () => import('../../pages/StudentInformation/LoansRightPanelDetails.vue');
const LoansInformationExcel = () => import('../../pages/StudentInformation/LoansInformationExcel.vue');
const LoanApplication = () => import('../../pages/StudentInformation/LoanApplication.vue');
const DeductionInfo = () => import('../../pages/StudentInformation/DeductionInfo.vue');
const RefundDetail = () => import('../../pages/StudentInformation/RefundDetail.vue');
const PrintRecord = () => import('../../pages/StudentInformation/PrintRecord.vue');
const DeductionRecord = () => import('../../pages/StudentInformation/DeductionRecord.vue');
const StudentLabel = () => import('../../pages/StudentInformation/StudentLabel.vue');
const StudentInLabel = () => import('../../pages/StudentInformation/StudentInLabel.vue');
const ImportStudent = () => import('../../pages/StudentInformation/ImportStudent.vue');
const RegistScores = () => import('../../pages/StudentInformation/RegistScores.vue');
const RegistScoresRightPanel = () => import('../../pages/StudentInformation/RegistScoresRightPanel.vue');
const ScoreRecord = () => import('../../pages/StudentInformation/ScoreRecord.vue');
const ImportRegistScore = () => import('../../pages/StudentInformation/ImportRegistScore.vue');
const ScoreRecordDetails = () => import('../../pages/StudentInformation/ScoreRecordDetails.vue');
const ReliefDetail = () => import('../../pages/StudentInformation/ReliefDetail');
const ImportScoreRecord = () => import('../../pages/StudentInformation/ImportScoreRecord');
const StudentsCanGraduate = () => import('../../pages/StudentInformation/StudentsCanGraduate');
const StudentsHistory = () => import('../../pages/StudentInformation/StudentsHistory');

const RightPanel = () => import('@/components/RightPanel.vue');// 右滑详情页面

export default [
	{
		name: 'ScoreRecord',
		path: '/ScoreRecord',
		component: ScoreRecord,
		children: [
			{
				path: 'ScoreRecordRightPanel',
				name: 'ScoreRecordRightPanel',
				meta: { parent: '/ScoreRecord' },
				component: RightPanel,
				children: [
					{
						path: '/ScoreRecordDetails/:key_id',
						name: 'ScoreRecordDetails',
						meta: { parent: '/ScoreRecord' },
						component: ScoreRecordDetails,
					},
				],
			},
		],
	},
	{
		name: 'ImportRegistScore',
		path: '/ImportRegistScore/:optType',
		component: ImportRegistScore,
	},
	{ name: 'BasicInformation', path: '/BasicInformation', component: BasicInformation },
	{ name: 'ImportScoreRecord', path: '/ImportScoreRecord/:optType', component: ImportScoreRecord },
	{ name: 'StudentsCanGraduate',
		path: '/StudentsCanGraduate',
		component: StudentsCanGraduate,
		children: [
			{
				path: '/AgencyFeeDetailRightPanel',
				name: 'AgencyFeeDetailRightPanel',
				component: RightPanel,
				children: [
					{
						path: '/studentDetial',
						name: 'studentDetial',
						component: () => import('@/pages/StudentInformation/studentDetial'),
						meta: { parent: '/StudentsCanGraduate' },
					},
				],
			},
		],
		meta: { title: '学生可毕业处理' },
	},
	{ name: 'StudentsHistory', path: '/StudentsHistory', component: StudentsHistory, meta: { title: '历史调整记录' } },
	{
		name: 'RegistScores',
		path: '/RegistScores',
		component: RegistScores,
		children: [
			{
				path: 'ReceiptPrintRightPanel',
				name: 'ReceiptPrintRightPanel',
				meta: { parent: '/LoansInformation' },
				component: RightPanel,
				children: [
					{ // 右滑详情页面
						path: '/RegistScoresRightPanel/:id',
						name: 'RegistScoresRightPanel',
						meta: { parent: '/LoansInformation' },
						component: RegistScoresRightPanel,
					},
				],
			},
		],
	},
	{ name: 'AmendRecord', path: '/AmendRecord', component: AmendRecord, meta: { parent: '/BasicInformation' } },
	{ name: 'BasicAddExcel', path: '/BasicAddExcel', component: BasicAddExcel, meta: { parent: '/BasicInformation' } },
	{ name: 'BasicUpdateExcel', path: '/BasicUpdateExcel', component: BasicUpdateExcel, meta: { parent: '/BasicInformation' } },
	{ name: 'EditStudentInfo', path: '/EditStudentInfo/:id', component: EditStudentInfo },
	{ name: 'AddStudentInfo', path: '/AddStudentInfo', component: EditStudentInfo },
	{ name: 'SquadManage', path: '/SquadManage', component: SquadManage },
	{ name: 'SquadManageExcel', path: '/SquadManageExcel', component: SquadManageExcel, meta: { parent: '/SquadManage' } },
	{
		name: 'LoansInformation',
		path: '/LoansInformation',
		component: LoansInformation,
		children: [
			{
				path: 'ReceiptPrintRightPanel',
				name: 'ReceiptPrintRightPanel',
				meta: { parent: '/LoansInformation' },
				component: RightPanel,
				children: [
					{ // 右滑详情页面
						path: '/LoansRightPanelDetails',
						name: 'LoansRightPanelDetails',
						meta: { parent: '/LoansInformation' },
						component: LoansRightPanelDetails,
					},
				],
			},
		],
	},
	{ name: 'LoansInformationExcel', path: '/LoansInformationExcel', component: LoansInformationExcel },
	{ name: 'StudentLabel', path: '/StudentLabel', component: StudentLabel },
	{ name: 'StudentInLabel', path: '/StudentInLabel/:key_id', component: StudentInLabel },
	// :optType add 导表添加 delete 导表删除
	{ name: 'ImportStudent', path: '/ImportStudent/:optType/:key_id', component: ImportStudent },

	// 减免信息
	{
		path: '/ReliefInformation',
		name: 'ReliefInformation',
		component: ReliefInformation,
		children: [
			{
				path: 'reliefRightPanel',
				name: 'reliefRightPanel',
				meta: { parent: '/ReliefInformation' },
				component: RightPanel,
				children: [
					{
						path: '/ReliefDetail/:id',
						name: 'ReliefDetail',
						meta: { parent: '/ReliefInformation' },
						component: ReliefDetail,
					},
				],
			},
		],
	},
	{
		path: '/StuDelayInfo',
		name: 'StuDelayInfo',
		component: StuDelayInfo,
	},
	{
		path: '/TransactionInfo',
		name: 'TransactionInfo',
		component: TransactionInfo,
	},
	// 异动类型管理
	{
		path: '/DiffManagement',
		name: 'DiffManagement',
		component: DiffManagement,
	},
	{
		path: '/BriefDepositControl',
		name: 'BriefDepositControl',
		component: BriefDepositControl,
	},
	{
		path: '/ReliefInformationExcel',
		name: 'ReliefInformationExcel',
		component: ReliefInformationExcel,
	},
	{
		path: '/StuDelayInfoExcel',
		name: 'StuDelayInfoExcel',
		component: StuDelayInfoExcel,
	},
	{
		path: '/LoanApplication',
		name: 'LoanApplication',
		component: LoanApplication,
	},
	{
		path: '/DeductionInfo',
		name: 'DeductionInfo',
		component: DeductionInfo,
	},
	{
		path: '/ZcRefundDetail',
		name: 'ZcRefundDetail',
		component: RefundDetail,
	},
	{
		path: '/ZcPrintRecord',
		name: 'ZcPrintRecord',
		component: PrintRecord,
	},
	// {
	// 	path: '/DeductionRecord',
	// 	name: 'DeductionRecord',
	// 	component: DeductionRecord,
	// },
];
